<template>
  <v-textarea
    auto-grow
    dense
    outlined
    rows="1"
    :label="$t('common.answer')"
    :resize="false"
    :value="response"
    :disabled="loading"
    :rules="rules"
    @input="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'TextForm',

  props: {
    response: {
      type: String,
      required: false,
      default: '',
      loading: Boolean,
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
